import * as React from "react";
import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";

/** Shared controlled search field with a consistent, accessible clear action. */
export const SearchField = React.forwardRef(({
  value = "", onChange, onClear, className, containerClassName,
  iconClassName, clearClassName, clearTestId, ...props
}, ref) => {
  const inputRef = React.useRef(null);
  React.useImperativeHandle(ref, () => inputRef.current);
  const clear = () => {
    if (onClear) onClear();
    else onChange?.({ target: { value: "" }, currentTarget: { value: "" } });
    inputRef.current?.focus();
  };

  return (
    <div className={cn("relative min-w-0", containerClassName)}>
      <Search aria-hidden="true" className={cn("pointer-events-none absolute left-3 top-1/2 z-10 h-4 w-4 -translate-y-1/2 text-slate-500", iconClassName)} />
      <Input ref={inputRef} type="search" value={value} onChange={onChange}
        className={cn("pl-9 pr-9 [&::-webkit-search-cancel-button]:hidden", className)} {...props} />
      {String(value).length > 0 && (
        <button type="button" data-testid={clearTestId} aria-label="Clear search" onClick={clear}
          className={cn("absolute right-2.5 top-1/2 z-10 -translate-y-1/2 p-1 text-slate-500 transition-colors hover:text-[var(--erp-text)] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[var(--erp-focus-ring)]", clearClassName)}>
          <X className="h-3.5 w-3.5" />
        </button>
      )}
    </div>
  );
});
SearchField.displayName = "SearchField";
